import React from 'react'

const TopHeaderPanel = () => {
  return (
    <>
      <div className='topheaderpanel'>
        <button className=''>
          <span><i className='ri-code-line'></i></span>
          <span>Code</span>
        </button>
        <button className=''>
          <span><i className='bx bx-slider'></i></span>
          <span>Controls</span>
        </button>
        <button className=''>
          <span><i className='mdi mdi-snowflake'></i></span>
          <span>Freeze</span>
        </button>
        <button className=''>
          <span><i className='mdi mdi-dots-horizontal'></i></span>
          
        </button>
      </div> 
    </>
  )
}

export default TopHeaderPanel